import * as React from 'react';
import ProjectCard from './ProjectCard';
import sun from "../images/Sun.png";
import goodreads from "../images/book.jpg";
import dreampopping from "../images/DP.png";
import itsoknow from "../images/itsoknow.png";
import sun2 from "../images/Sun2.png";
import goodreads2 from "../images/book2.jpg";
import dreampopping2 from "../images/DP2.png";
import itsoknow2 from "../images/itsoknow2.png";
import "../styles/projects.css";


function Projects() {

  return (
  	<div className="grid">
  	  <div className="pastprojects" style={{ backgroundColor: '#C3B1E1', width: '100%', height: '150px'}}>
  	    <h1 style={{ paddingTop: "4%", marginBottom: "10%" }}>Past Projects</h1>
  	  </div>
		<div className="projectsGridRow1">
	    <ProjectCard link="https://drive.google.com/file/d/1XnO_04_X8XezCI72fMYSy2WTMFrz8u8u/view"
				     description="Guided Journaling iOS App"
				     image1={sun}
					 image2={sun2}
				     alt="This is the logo of a sun for FelicityCBT."
		/>
  	    <ProjectCard link="https://drive.google.com/file/d/1gWMt8OX-3WSXzj3YCHgKstv3c_J_xnG3/view"
				     description="How would a Goodreads user rate a book?"
				     image1={goodreads}
				     image2={goodreads2}
				     alt="An open book that represents Goodreads."
		/>
	  </div>
	  <div className="projectsGridRow2">
  	    <ProjectCard link="https://drive.google.com/file/d/1iPItkAyvwXGRJbmCvt3flV7UE39_XEH1/view?usp=sharing"
				     description="Financial Literacy Android Gaming App"
				     image1={dreampopping}
				     image2={dreampopping2}
				     alt="This is the front page of the mobile app with a red balloon."
		/>
  	    <ProjectCard link="https://itsoknow.org/"
				     description="Teen Wellness Landing Page"
				     image1={itsoknow}
				     image2={itsoknow2}
				     alt="This is an orange circle with text inside stating: A mental wellness hub for teens and pre-teens."
		/>
	  </div>
	</div>
  );
}

export default Projects;
